import React, { useState } from 'react';

import { Text, useThemeMode } from 'app/shopify/theme';
import { Column, Row } from 'app/shopify/components/layout';

import { Switch } from './Switch';

export function SwitchShowcase() {
  const [isSelected, setIsSelected] = useState(true);
  const { isDark, toggleMode } = useThemeMode();

  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <Text variant="bodySmall" color="text.secondary">
        Switch - etats selected/not-selected en enabled/disabled, tailles default et small.
      </Text>

      <Row gap="spacing.general.x3">
        <Switch label="Dark mode" showLabel selected={isDark} onPress={toggleMode} />
      </Row>

      <Row gap="spacing.general.x3">
        <Switch selected={isSelected} onPress={() => setIsSelected((prev) => !prev)} />
      </Row>

      <Row gap="spacing.general.x3">
        <Switch selected state="enabled" size="default" />
        <Switch selected state="disabled" size="default" />
        <Switch selected={false} state="enabled" size="default" />
        <Switch selected={false} state="disabled" size="default" />
      </Row>

      <Row gap="spacing.general.x3">
        <Switch selected state="enabled" size="small" />
        <Switch selected state="disabled" size="small" />
        <Switch selected={false} state="enabled" size="small" />
        <Switch selected={false} state="disabled" size="small" />
      </Row>
    </Column>
  );
}
